// İzin Aksiyonları (api-contract §30.5/§35.1) API'den ESKİDEN YENİYE gelir
// (backend: ORDER BY at, id — `id` yanıtta YOK). UI en yeni üstte okur.
// Backend ayrıca okuma anında sentetik bir `Expired` satırı ekler
// (`PermitProjection.LoadActivitiesAsync`); bu satır, aynı `at`'e sahip saklı
// kayıtların ARDINDA gelir. Bu yüzden sıra `at`/`id`'den yeniden kurulamaz.
// Eşit `at` kayıtlarının kararlılığı yalnız dizinin BİREBİR tersine bağlıdır:
// zamana göre yeniden SIRALAMA YAPMA, tekilleştirme de YAPMA. `toReversed` ES2023'tür; bu paketin lib'i ES2022.
// Girdiyi (TanStack Query cache'i dahil) mutasyona uğratmaz.
export function newestFirst<T>(apiOrdered: readonly T[]): T[] {
  return [...apiOrdered].reverse();
}
